import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { connect } from "react-redux";
// import Fade from 'react-reveal/Fade'
import FormAction from "./formAction";

function ApplicationFee(props) {
  const [state, setState] = useState({
    formData: {
      percent_completed: 100,
      is_fee_paid: null,
    },
    is_fee_paidValid: "",
    isFormDataValid: false,
  });

  const numberInputs = {};
  const stepFields = ["is_fee_paid"];

  const { savedSteps, selectedProgramId, selectedProgramLabel } = useSelector(
    (state) => ({
      savedSteps: state.applicationReducer.savedSteps,
      selectedProgramId: state.applicationReducer.selectedProgramId,
      selectedProgramLabel: state.applicationReducer.selectedProgramLabel,
    }),
    shallowEqual
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!!savedSteps.applicationFee) {
      populateForm();
    }
  }, []);

  useEffect(() => {
    validateForm();
  }, [state]);

  function populateForm() {
    const applicationFeeData = savedSteps.applicationFee;
    if (
      !!savedSteps.applicationFee &&
      Object.keys(applicationFeeData).length > 0
    ) {
      updateForm("is_fee_paid", applicationFeeData.is_fee_paid);
    }
  }

  const updateForm = (field, value) => {
    let temp = state.formData;
    temp[field] = value;
    setState((prevState) => ({ ...prevState, formData: temp }));
    _validate(field);
  };
  const _validate = (field) => {
    let regex, valid;
    let value = state.formData[field];
    switch (field) {
      case "is_fee_paid":
        regex = /^.{1,}/;
        valid = regex.test(value);
        break;
    }
    setState((prevState) => ({ ...prevState, [field + "Valid"]: valid }));
  };

  const validateForm = () => {
    let formData = state;
    let form = !!formData.is_fee_paidValid;
    if (state.isFormDataValid != form) {
      setState((prevState) => ({ ...prevState, isFormDataValid: form }));
    }
  };

  return (
    <>
      <div className="app-form-container demographic residency">
        <div className="main-heading bayan-main-heading">
          {selectedProgramLabel}
        </div>
        <div className="sub-heading app-info">Application Fee</div>
        <div className="form-content">
          <div className="input-group">
            <div className="field-label">
              <p>I have paid my application fee. *</p>
              I have paid my application fee. * A non-refundable $50 application
              fee is required of all online applicants. Persons serving as
              volunteers, team members, Corp members, staff and alums of the
              AmeriCorps, City Year, Peace Corps, and VISTA are eligible for an
              application fee waiver. Applicants must provide proof of
              affiliation in order to utilize the fee waiver option. Your
              application fee can be paid online:
              <br />
              <p>
                <a href="#">https://mkt.com/CTSappandmatfee/</a>
              </p>
            </div>
            <div className="inline-f-b mt-20">
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div
                    className={`radio-button ${
                      state.formData.is_fee_paid == 1 ? "selected" : ""
                    }`}
                    onClick={() => {
                      updateForm("is_fee_paid", 1);
                    }}
                  ></div>
                  <div
                    className={`radio-label`}
                    onClick={() => {
                      updateForm("is_fee_paid", 1);
                    }}
                  >
                    Yes
                  </div>
                </div>
              </div>
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div
                    className={`radio-button ${
                      state.formData.is_fee_paid == 0 ? "selected" : ""
                    }`}
                    onClick={() => {
                      updateForm("is_fee_paid", 0);
                    }}
                  ></div>
                  <div
                    className={`radio-label`}
                    onClick={() => {
                      updateForm("is_fee_paid", 0);
                    }}
                  >
                    Not Yet!
                  </div>
                </div>
              </div>
            </div>
            {state.is_fee_paidValid === false && (
              <div className="field-error">Must select an option.</div>
            )}
          </div>
        </div>
      </div>
      <FormAction
        isFormDataValid={state.isFormDataValid}
        formData={state.formData}
        formStep={"applicationFee"}
        backStep={"applicationEssay"}
        nextStep={""}
      />
    </>
  );
}

export default ApplicationFee;
